import { IEditorConfigOptions } from '../../../components';
import { TOOLBAR_GROUPS } from '../../../components/Editor/config/registry';

export interface IEditorCommonProps {
  disabled?: boolean;
  visible?: boolean;
  height?: string;
  placeholder?: string;
  menubar?: boolean;
  statusbar?: boolean;
  branding?: boolean;
  toolbarGroups?: (keyof typeof TOOLBAR_GROUPS)[];
  templateEnabled?: boolean;
  templateVisible?: boolean;
  templateId?: string;
  templateDataMapping?: string;
}

export const buildEditorConfig = (
  props: IEditorCommonProps
): IEditorConfigOptions => ({
  toolbarGroups: props.toolbarGroups || [],
  features: props.templateVisible ? { loadFromTemplate: true } : {},
  core: {
    height: Number(props.height),
    placeholder: props.placeholder,
    menubar: props.menubar,
    statusbar: props.statusbar,
    branding: props.branding,
  },
  additionalOptions: {},
});
